module.exports = __webpack_public_path__ + "static/1-2935962b5e76e4f5f474ca2c1c612bea.jpg";